document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const menus = document.querySelectorAll('.header__inline-menu details');
  
  // Track if any menu is open
  let activeMenu = null;
  let closeTimer = null;
  let openTimer = null; // NEW: Timer for delayed opening
  
  // Function to close all menus
  const closeAllMenus = () => {
    menus.forEach(menu => {
      menu.removeAttribute('open');
    });
    activeMenu = null;
    
    // CRITICAL: Also remove any lingering backdrop
    const backdrop = document.getElementById('menu-backdrop');
    if (backdrop) {
      backdrop.style.display = 'none';
    }
  };
  
  // Function to clear any existing timer
  const clearCloseTimer = () => {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  };
  
  // NEW: Function to clear the open timer
  const clearOpenTimer = () => {
    if (openTimer) {
      clearTimeout(openTimer);
      openTimer = null;
    }
  };
  
  // Check if we're still hovering over any part of the mega menu system
  const isHoveringMenuSystem = () => {
    const megaMenuAreas = [
      ...document.querySelectorAll('.header__inline-menu details'),
      ...document.querySelectorAll('.mega-menu__content'),
      ...document.querySelectorAll('.mega-menu')
    ];
    
    return megaMenuAreas.some(element => 
      element && element.matches(':hover')
    );
  };
  
  // Handle menu hover with intent detection
  menus.forEach(menu => {
    const summary = menu.querySelector('summary');
    const content = menu.querySelector('.mega-menu__content');
    
    // Mouse enters the menu item - DELAYED OPENING
    menu.addEventListener('mouseenter', () => {
      clearCloseTimer();
      clearOpenTimer(); // Clear any existing open timer
      
      // Set a timer to open the menu after a delay (e.g., 300ms)
      openTimer = setTimeout(() => {
        // If there's already a different menu open, close it first
        if (activeMenu && activeMenu !== menu) {
          activeMenu.removeAttribute('open');
        }
        
        // Open this menu
        menu.setAttribute('open', true);
        activeMenu = menu;
        openTimer = null;
      }, 300); // Adjust this delay as needed (300ms is a good starting point)
    });
    
    // Mouse leaves the menu item
    menu.addEventListener('mouseleave', () => {
      // Clear the open timer if user leaves before it fires
      clearOpenTimer();
      clearCloseTimer();
      
      // Give a small delay to allow moving to the dropdown content
      closeTimer = setTimeout(() => {
        if (!isHoveringMenuSystem()) {
          closeAllMenus();
        }
      }, 100);
    });
    
    // Also handle the content area
    if (content) {
      content.addEventListener('mouseenter', () => {
        clearCloseTimer();
        clearOpenTimer(); // Clear open timer when already in content
      });
      
      content.addEventListener('mouseleave', () => {
        clearCloseTimer();
        closeTimer = setTimeout(() => {
          closeAllMenus();
        }, 100);
      });
    }
  });
  
  // Handle regular (non-mega) menu items
  document.querySelectorAll('.header__inline-menu > ul > li:not(:has(details))').forEach(item => {
    item.addEventListener('mouseenter', () => {
      clearOpenTimer(); // Clear any pending open timers
      clearCloseTimer();
      closeAllMenus();
    });
  });
  
  // Handle leaving the entire header area
  if (header) {
    header.addEventListener('mouseleave', () => {
      clearOpenTimer(); // Clear any pending open timers
      clearCloseTimer();
      closeAllMenus();
    });
  }
  
  // ADD THIS: Clean up on page scroll and resize
  window.addEventListener('scroll', () => {
    clearOpenTimer(); // Clear any pending open timers
    clearCloseTimer();
    closeAllMenus();
  });
  
  window.addEventListener('resize', () => {
    clearOpenTimer(); // Clear any pending open timers
    clearCloseTimer();
    closeAllMenus();
  });
});